import { useContext } from 'react';
import { UsersContext } from '../context/users-context';

export function useUser() {
  const userContext = useContext(UsersContext);
  return userContext;
}

export default useUser;
